export default __webpack_public_path__ + "static/media/elena-site-logo-558_x_106-removebg-preview.0a0f6164.png";